'use client'

export default function GlobalError({
	error,
	reset,
}: Readonly<{ error: Error & { digest?: string }; reset: () => void }>) {
	console.error('GLOBAL_ERROR', {
		message: error?.message,
		stack: error?.stack,
		digest: error?.digest,
	})

	return (
		<div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4">
			<div className="text-center space-y-4 max-w-md">
				<h2 className="text-xl font-semibold">Algo deu errado.</h2>
				<p className="text-sm text-muted-foreground">
					Não foi possível carregar esta página. Tente novamente em instantes — se persistir, entre novamente ou
					avise o time.
				</p>
				{/* `reset()` sozinho é beco sem saída quando a causa é a API indisponível:
				    re-renderizar reproduz o mesmo erro. O link pro login dá uma saída. */}
				<div className="flex items-center justify-center gap-3">
					<button
						onClick={() => reset()}
						className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
					>
						Tentar novamente
					</button>
					<a href="/login" className="px-4 py-2 border border-border rounded-md hover:bg-muted transition-colors">
						Voltar ao login
					</a>
				</div>
				{/* Correlaciona com o log do servidor: em produção o Next sanitiza a
				    mensagem de erro de Server Components, e o digest é o único elo. */}
				{error?.digest && <p className="text-xs text-muted-foreground">Código: {error.digest}</p>}
			</div>
		</div>
	)
}
